<style scoped>
    @import url("../../styles/smartControl/alertSC.scss");
</style>

<template>
    <div class="box_alertSC">

        <div class="painelGeral" v-if="flagMsgSistema">
            <span>Selecione um sistema na página "Início"</span>
            <v-icon class="ml-1">mdi-view-quilt-outline</v-icon>
        </div>

        <!-- LOADING após search btn -->
        <div v-if="flagLoading" class="mb-16 mt-16"
        :style="{'display':'flex','width':'100%','align-items':'center','justify-content':'center'}">
            <v-progress-circular 
                color="black"
                size="64"
                indeterminate
            ></v-progress-circular>
        </div>

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-timeline-alert-outline</v-icon>
            <span class="ml-2">Configuração de alerta</span>
        </div>

        <div class="painelGeral" v-if="!flagLoading && !flagMsgSistema">
            <AlertConfig />
        </div>

        <div class="titGeral">
            <v-icon :style="{'color':'rgb(31,122,177)'}">mdi-alert-box-outline</v-icon>
            <span class="ml-2">Alertas e notificações</span>
        </div>

        <div class="painelGeral" v-if="!flagLoading && !flagMsgSistema">
            <AlertExibTable :key="execSys" :execSys="execSys" :emailCliente="emailCliente" />
        </div>

    </div>
</template>

<script>
//import axios from 'axios'
import AlertExibTable from './subAlert/AlertExibTable'
import AlertConfig from './subAlert/AlertConfig'

export default {

    components:{AlertExibTable, AlertConfig},

    data() {
        return {
            //
            //r:'/dadoslipordia',

            // loading
            flagLoading:true,

            flagMsgSistema:false, // condiciona busca se o sistema tiver sido selecionado no init.

            emailCliente:'', // -- cliente logado
            execSys:'', // -- sistema current exib
        }
    },

    methods:{

        preInit() {

            /*let emailCliente = this.$store.state.emailCliente // -- atualizado em SmartControl.vue (pai de todos) | 13/08/2025

            const headers = {
                'Authorization': `Bearer ${this.$store.state.tox}`,
                'Content-Type': 'application/json'
            }

            let self = this

            let params = { 'cliente': emailCliente }

            let url = self.$store.state.pathAxiosBASE + '/getsysuser' // concat

            axios.post(url, params, {headers}).then(function (res) {

                //console.log(res.data.result)
                let lisys = res.data.result
                self.liExecSys = lisys

                self.flagLoading = false // -- encerrar loading
            })*/
           this.flagLoading = false
        },
    },

    created() {
        window.scrollTo(0,0)

        // -- obter nome cliente logado (email).
        this.emailCliente = this.$store.state.emailCliente
        //console.log('[father alert] this.emailCliente: ',this.emailCliente)

        // -- obter sistema atual selecionado.
        this.execSys = this.$store.state.sistemaSC
        //console.log('[father alert] execSys: ',this.execSys)

        // -- se sistema vazio, então não buscar o sistema...
        if (this.execSys == '') { this.flagMsgSistema = true; return; } 
        else { 
            this.flagMsgSistema = false
            this.preInit()
        }
    }
}
</script>